import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./responsiveness.css";
import App from "./App";
import AppContextProvider from "./Contexts/AppContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppContextProvider>
    <App />
  </AppContextProvider>
);
